// extracted by mini-css-extract-plugin
module.exports = {"speakerModal":"SpeakerModal_speakerModal__1diAK","arrowLeft":"SpeakerModal_arrowLeft__37Y-K","arrowRight":"SpeakerModal_arrowRight__Rptt2","btns":"SpeakerModal_btns__1MTKc"};